<template>
	<div class="counter">
		<p class="counter-label" v-if="hasSlot">
			<slot></slot>
		</p>
		<div class="counter-numbers" v-if="total >= 0">
			{{ current }}<span class="total-separator"> / </span>{{ total }}
		</div>
		<div class="counter-numbers" v-else>
			{{ current }}
		</div>
	</div>
</template>

<script>
	export default {
		name: 'counter',
		props: {
			current: {
				type: Number,
				required: false,
				default: 0
			},
			total: {
				type: Number,
				required: false,
				default: -1
			}
		},
		computed: {
			hasSlot() {
				return !!this.$slots.default;
			}
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/font-sizes.less";

	.counter-numbers {
		font-size: @app-font-size-counter-numbers;
		line-height: 0.75;
		font-weight: 700;
	}

	.counter-label {
		font-size: @app-font-size-counter-label;
		line-height: @app-font-size-counter-label;
		font-weight: 700;
		margin-bottom: 15px;
	}
</style>
